export default __webpack_public_path__ + "static/media/processBusiness.3516ed78.png";